import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import pdfToText from 'react-pdftotext';
import mammoth from 'mammoth';
import { api } from '../apiService';
import { toast } from 'react-toastify';
import { useAuth } from '../AuthContext';

const UploadExtractCV = ( {onChange} ) => {
  const { user } = useAuth();
  const profile_email = user?.email;

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    let rawText = "";
    if (file.type === "application/pdf") {
      rawText = await pdfToText(file);
    } else if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.extractRawText({ arrayBuffer });
      rawText = result.value;
    }

    // Pass rawText to your AI parser
    parseTextWithAI(rawText);
  };


  const parseTextWithAI = async (text) => {
    const [data, error] = await api.post(`cv_extract_info/?profile_email=${profile_email}`, {text: text});
    if (data){
      onChange(data);
      }
  };

  return (
    <Form.Group className="mb-4 p-3 border rounded bg-light">
      <Form.Label className="fw-bold">Auto-fill from Resume/Profile</Form.Label>
      <Form.Control
        type="file"
        accept=".pdf,.docx"
        onChange={handleFileUpload}
      />
      <Form.Text className="text-muted">Upload PDF or DOCX to automatically fill the fields below.</Form.Text>
    </Form.Group>

  );
}

export default UploadExtractCV;